/**
 * LA Question Form
 * Requires jQuery and s.ui.filedrop
 * @deprecated js/public/QuestionForm.js is preferred but we have to keep both in sync until we switch over.
 */

(function (root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};
    const AUTOREPLY_TYPE_OFFHOURS = 2;

    const Pbkdf2Worker = class {
        constructor(workerUrl) {
            // Same-origin: load directly. Cross-origin: blob+importScripts, because browsers
            // enforce same-origin on the initial worker script URL even for module workers with
            // CORS headers. The embedding page's CSP (not LA's) governs blob: in that context.
            if (new URL(workerUrl).origin === window.location.origin) {
                return new Worker(new URL(workerUrl), { type: 'module' });
            }
            const blob = new Blob(
                [`importScripts(${JSON.stringify(workerUrl)})`],
                { type: 'text/javascript' },
            );
            const objectUrl = URL.createObjectURL(blob);
            const worker = new Worker(objectUrl);
            URL.revokeObjectURL(objectUrl);
            return worker;
        }
    };

    /**
     * Question form js
     * @param {Object} config configuration data
     * @param {String} config.form_action Action attribute for the form, set it in js to help with spam??
     * @param {String} config.content_id box_content.id value
     * @param {Number} config.queue_id Form's Queue ID
     * @param {Object} config.errormsg Error message translation object
     * @param {Object} config.translations Translations for the filedrop widget.
     * @param {Boolean} config.libauth_enabled Is Libauth Turned on for this form.
     * @param {Boolean} config.libauth_authed Is the requester validated for libauth.
     * @param {Object} config.autoReplySettings Queue auto reply type, etc.
     * @param {Object[]} config.rules Field rules
     */
    const askform = function (config) {
        this.id = config.content_id;
        this.queue_id = config.queue_id;
        this.errormsg = config.errormsg;
        this.divselector = `#s-la-askform-${this.id}`;
        this.$form = jQuery(`${this.divselector} form`);
        this.translations = config.translations;
        this.form_action = config.form_action;
        this.libauth_enabled = config.libauth_enabled || false;
        this.libauth_authed = config.libauth_authed || false;
        this.autoReplySettings = new root.springSpace.la.FormAutoReply(config.autoReplySettings || {});
        this.captcha_enabled = this.autoReplySettings.isCaptchaEnabled();
        this.autoreply_enabled = this.autoReplySettings.isAutoReplyEnabled();
        this.captchaDiv = this.$form[0].querySelector('.formlibcpt');
        this.confirmEmailDiv = this.$form[0].querySelector('.confem_wrap');
        this.autoreply_type = this.autoReplySettings.getAutoReplyType();
        if (this.captcha_enabled) {
            this.captchaDiv.classList.remove('hidden');
        }
        if (Array.isArray(config.rules)) {
            this.rules = config.rules.map((r) => {
                return new root.springSpace.la.FormFieldRule(r);
            });
        } else {
            this.rules = [];
        }

        /**
         * When a required checkbox is changed we have to adjust the required attribute
         * on all of them else the browser will not validate
         * @param {Event} ev Checkbox input change.
         */
        this.handleRequiredCheckBoxes = function (ev) {
            const fieldName = ev.target.name;
            const isChecked = (ev.target.checked === true);
            // if checked remove required from related inputs.
            if (isChecked) {
                const relatedChecks = this.$form[0].querySelectorAll(`input[type=checkbox][name="${fieldName}"]`);
                if (relatedChecks.length > 0) {
                    Array.prototype.forEach.call(relatedChecks, (el) => {
                        el.removeAttribute('required');
                    }, this);
                }
                return;
            }
            // if unchecked confirm if others are checked.
            const fieldSet = ev.target.closest('fieldset');
            if (fieldSet === null) {
                return;
            }
            // Get checked boxes (if any)
            const checkedBoxes = fieldSet.querySelectorAll('input[type=checkbox]:checked');
            if (checkedBoxes.length > 0) {
                // Others are checked so all good.
                return;
            }
            Array.prototype.forEach.call(fieldSet.querySelectorAll('input[type=checkbox]'), (el) => {
                el.setAttribute('required', '');
            }, this);
        };
        /**
         * Add error on the form
         * @param {HTMLElement} input Element for input/select
         * @param {String} msg Error message
         */
        this.markError = function (input, msg) {
            if (!input) {
                return;
            }
            const msg_div = document.createElement('div');
            msg_div.classList.add('error-message');
            msg_div.innerHTML = msg;
            const parent = input.closest('div.form-group');
            if (parent === null) {
                return;
            }
            input.setAttribute('aria-invalid', 'true');
            parent.classList.add('has-error');
            const label = parent.querySelector('label');
            if (label) {
                label.appendChild(msg_div);
            }
        };
        this.loadCaptcha = function () {
            const url = new URL(this.form_action);
            globalThis.$altcha.algorithms.set('PBKDF2/SHA-256', () => new Pbkdf2Worker(`https://${url.hostname}/altcha-worker.js`));
            const widget = document.createElement('altcha-widget');
            widget.setAttribute('challenge', `https://${url.hostname}/form/altcha-challenge`);
            widget.setAttribute('name', 'altcha');
            widget.setAttribute('type', 'native');
            this.captchaDiv.innerHTML = '';
            this.captchaDiv.appendChild(widget);
            this.captchaDiv.classList.add('active');
            this.captchaDiv.classList.remove('hidden');
            widget.addEventListener('statechange', (ev) => {
                if (ev.detail?.state === 'error') {
                    this.loadFallbackCaptcha();
                }
            });
        };
        this.loadFallbackCaptcha = function () {
            const url = new URL(this.form_action);
            jQuery.ajax({
                context: this,
                type: 'GET',
                url: `https://${url.hostname}/form/captcha-fallback`,
                data: { bs5: 0 },
                dataType: 'json',
            }).done(({ html = '' }) => {
                if (!html) {
                    return;
                }
                this.captchaDiv.innerHTML = html;
                const reloadBtn = this.captchaDiv.querySelector('.btn-cptreload');
                if (reloadBtn) {
                    reloadBtn.addEventListener('click', this.loadFallbackCaptcha.bind(this));
                }
                this.captchaDiv.querySelector('input[type="text"]')?.focus();
            }).fail(() => {
                this.captchaDiv.classList.add('hidden');
            });
        };
        /**
         * Validate a single field for if it is set.
         * @param {Object} el DOMElement fields we are validating.
         */
        this.validateField = function (el) {
            if (!el || el.disabled) {
                return;
            }
            if (el.tagName === 'SELECT') {
                const option = el.options[el.selectedIndex] || null;
                if (!option) {
                    return;
                }
                const value = option.value;
                if (value === '' || value === '0') {
                    this.markError(el, this.errormsg.reqfields);
                }
                return;
            }
            if (el.tagName === 'TEXTAREA') {
                if (el.value.trim() === '') {
                    this.markError(el, this.errormsg.reqfields);
                }
                return;
            }
            if (el.tagName !== 'INPUT') {
                return;
            }
            // Ok just INPUT tags now.
            const inputType = el.type;
            // Radio and checkbox are handled as groups
            if (inputType === 'radio' || inputType === 'checkbox') {
                return;
            }
            if (inputType === 'email') {
                if (!el.checkValidity()) {
                    this.markError(el, this.errormsg.emailaddress);
                }
                if (el.name === 'confirm_pemail') {
                    const emailElem = this.$form[0].querySelector('input[name="pemail"]');
                    if (el.value.trim() !== emailElem.value.trim()) {
                        this.markError(el, this.errormsg.emailnotmatch);
                    }
                }
                return;
            }
            // The rest... text mostly.
            if (el.value.trim() === '') {
                this.markError(el, this.errormsg.reqfields);
            }
        };
        /**
         * Validate a URL field
         * @param {HTMLElement} el element
         */
        this.validateURL = function (el) {
            if (!el.reportValidity()) {
                this.markError(el, el.validationMessage);
            }
        };
        /**
         * Validate checkbox and radio groups.
         * @param {HTMLElement} fieldset A fieldset element.
         */
        this.validateFieldSet = function (fieldset) {
            const inputs = fieldset.querySelectorAll('input');
            let isValid = true;
            inputs.forEach((input) => {
                if (!input.checkValidity()) {
                    isValid = false;
                    input.setAttribute('aria-invalid', 'true');
                }
            });
            if (isValid) {
                return;
            }

            const msg_div = document.createElement('div');
            msg_div.classList.add('error-message');
            msg_div.innerHTML = this.errormsg.reqfields;

            fieldset.classList.add('has-error');
            const legend = fieldset.querySelector('legend');
            if (legend) {
                legend.appendChild(msg_div);
                return;
            }
        };
        /**
         * Validate the form before submitting.
         * @return {Boolean}
         */
        this.validate = function () {
            if (this.libauth_enabled && !this.libauth_authed) {
                return false;
            }
            this.$form.attr('action', this.form_action);
            this.$form.find('label .error-message, legend .error-message').remove();
            this.$form.find('.form-group').removeClass('has-error');
            this.$form.find('.form-control, input[type=radio], input[type=checkbox]').attr('aria-invalid', false);
            // check "required fields" for validity
            Array.from(this.$form[0].querySelectorAll('[required]:not([type="url"])')).forEach((el) => {
                this.validateField(el);
            });
            this.$form[0].querySelectorAll('input[type=url]').forEach((el) => {
                this.validateURL(el);
            });
            // check required radio/checkbox groups
            Array.from(this.$form[0].querySelectorAll('fieldset[data-required]')).forEach((el) => {
                this.validateFieldSet(el);
            });

            if (this.$form.find('.has-error').length > 0) {
                this.$form.find('*[aria-invalid=true]:first').trigger('focus');
                return false;
            }
            let qlog_id = 0;
            if (root.springSpace.queryAnalyzer) {
                qlog_id = root.springSpace.queryAnalyzer.qlog_id || 0;
            } else if (root.springSpace.la.Page && root.springSpace.la.Page.qlog_id) {
                qlog_id = root.springSpace.la.Page.qlog_id;
            }
            if (qlog_id > 0) {
                this.$form.find('input[name=qlog]').val(qlog_id);
            }

            root.suiNotify.working();
            return true;
        };

        /**
         * Create a dismissable alert for insertion into the DOM.
         * Uses bootstrap alert classes.
         * @param {String} message HTML Error message (html)
         * @param {String} colorClass Bootstrap based (danger, success, info, etc.)
         * @returns {HTMLElement}
         */
        this.createDismissableAlert = function (message, colorClass) {
            const alert = document.createElement('div');
            alert.classList.add('alert', `alert-${colorClass}`, 'alert-dismissable');
            alert.setAttribute('role', 'alert');
            alert.setAttribute('aria-atomic', 'true');
            const button = document.createElement('button');
            button.type = 'button';
            button.classList.add('close');
            button.setAttribute('aria-label', 'close');
            button.innerHTML = '<span aria-hidden="true">&times;</span>';
            alert.appendChild(button);
            alert.insertAdjacentHTML('beforeend', message);
            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                alert.remove();
            });
            return alert;
        };

        /**
         * Trigger change event on rule fields to reset visibility
         */
        this.resetRules = function () {
            this.rules.forEach((rule) => {
                this.$form[0].querySelectorAll(`*[name="${rule.field1}"], *[name="${rule.field1}[]"]`).forEach((el) => {
                    el.dispatchEvent(new Event('change'));
                });
            });
        };

        /**
         * Instantiate filedrop object to handle validation, submit, error, etc.
         */
        this.questionform = new root.springSpace.sui.filedrop({
            selector: `${this.divselector} form`,
            max_files: 5,
            max_upload_size: 20971520,
            max_file_size: 20971520,
            batch_files: false,
            autoupload: false,
            supportie9: false,
            translations: this.translations,
            callback: (data) => {
                // Insert an alert above the submit button.
                root.suiNotify.hide();
                const alert = this.createDismissableAlert(data.message, 'success');
                const buttonDiv = this.$form[0].querySelector('#s-la-askform-buttons');
                buttonDiv.insertAdjacentElement('beforebegin', alert);
                this.questionform.reset();
                this.resetRules();
                if (this.captcha_enabled) {
                    this.loadCaptcha();
                }
                if (this.autoreply_enabled && this.confirmEmailDiv) {
                    // remove confirmation field when auto reply is enabled
                    this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = true;
                    this.confirmEmailDiv.classList.add('hidden');
                }
            },
            error_callback: (jqXhr) => {
                let error = 'Error';
                const isCaptcha = jqXhr.status === 449;
                if (jqXhr.responseText) {
                    try {
                        const response = JSON.parse(jqXhr.responseText);
                        if (response.error) {
                            error = response.error;
                        }
                    } catch {
                        error = 'Invalid response received';
                    }
                }
                root.suiNotify.hide();
                const alert = this.createDismissableAlert(error, 'danger');
                let errorContain = null;
                let location = 'beforebegin';
                if (isCaptcha) {
                    errorContain = this.$form[0].querySelector('.formlibcpt');
                    if (errorContain) {
                        location = 'afterbegin';
                    }
                }
                if (!errorContain) {
                    errorContain = this.$form[0].querySelector('#s-la-askform-buttons');
                }
                errorContain.insertAdjacentElement(location, alert);
            },
            validate: this.validate.bind(this),
        });

        this.showField = function (field) {
            field.classList.remove('hidden');
            field.querySelectorAll('select, input, textarea').forEach((input) => {
                input.disabled = false;
            });
        };

        this.hideField = function (field) {
            field.classList.add('hidden');
            field.querySelectorAll('select, input, textarea').forEach((input) => {
                if (['checkbox', 'radio'].includes(input.type)) {
                    input.checked = false;
                } else {
                    input.value = '';
                }
                // trigger change event to hide/show fields...
                input.dispatchEvent(new Event('change'));
                input.disabled = true;
            });
        };

        this.getMultiCheckValue = function (fieldname) {
            // get all checkbox values...
            const data = new FormData(this.$form[0]);
            return Array.from(data.getAll(fieldname)).map((el) => {
                return Number(el);
            });
        };

        this.getRadioValue = function (fieldname) {
            const data = new FormData(this.$form[0]);
            return Number(data.get(fieldname));
        };

        this.setUpRules = function () {
            this.rules.forEach((rule) => {
                this.$form[0].querySelectorAll(`*[name="${rule.field1}"], *[name="${rule.field1}[]"]`).forEach((el) => {
                    const field2 = this.$form[0].querySelector(`.${rule.field2}_wrap`);
                    if (!field2) {
                        return;
                    }
                    // then for later...
                    el.addEventListener('change', (ev) => {
                        let fieldValue = Number(ev.target.value);
                        if (ev.target.type === 'checkbox') {
                            // get all checkbox values...
                            fieldValue = this.getMultiCheckValue(ev.target.name);
                        } else if (ev.target.type === 'radio') {
                            fieldValue = this.getRadioValue(ev.target.name);
                        }
                        const action = rule.getFieldAction(fieldValue);
                        if (action === 0) { // show
                            this.showField(field2);
                        } else if (action === 1) { // hide
                            this.hideField(field2);
                        }
                    });
                });
            });
        };

        /**
         * Setup some events on the form.
         * This gets run first.
         */
        this.setUp = function () {
            // LibAuth on but current user not authed
            if (this.libauth_enabled && !this.libauth_authed) {
                // Disable inputs to stop focus
                this.questionform.$form[0].querySelectorAll('input,select,button,textarea').forEach((el) => {
                    el.disabled = true;
                });
                // make tabbable elements and links untabbable.
                this.questionform.$form[0].querySelectorAll('[tabindex="0"],a').forEach((el) => {
                    el.setAttribute('tabindex', '-1');
                });
                // hide form for screenreaders
                this.questionform.$form[0].setAttribute('aria-hidden', 'true');
                // If in iframe set auth link to open in new window.
                if (window !== window.top) {
                    const button = document.querySelector(`${this.divselector} .btn-libauth`);
                    if (button) {
                        button.setAttribute('target', '_blank');
                    }
                }
                return;
            }

            this.setUpRules();

            const reqChecks = this.questionform.$form[0].querySelectorAll('input[type=checkbox][required]');
            if (reqChecks.length > 0) {
                // Add change event for all required checkboxes.
                Array.prototype.forEach.call(reqChecks, function (el) {
                    el.addEventListener('change', this.handleRequiredCheckBoxes.bind(this));
                }, this);
            }
            if (this.captcha_enabled) {
                this.loadCaptcha();
            }
            if (this.autoreply_enabled && this.confirmEmailDiv) {
                // remove confirmation field when auto reply is enabled
                this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = true;
                this.confirmEmailDiv.classList.add('hidden');
            }
            if (!this.captcha_enabled && this.confirmEmailDiv) {
                const confemCheckbox = this.confirmEmailDiv.querySelector('input[type="checkbox"]');
                if (confemCheckbox) {
                    confemCheckbox.addEventListener('change', () => {
                        if (confemCheckbox.checked && !this.captcha_enabled) {
                            this.captcha_enabled = true;
                            this.loadCaptcha();
                        }
                    });
                }
            }
        };

        this.setUp();
    };

    root.springSpace.la.askform = askform;
})(window);
